import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { getTripType } from "../utils";
import { PRIORITY_BOARDING_ROUTES } from "./defines/priorityBoardingRoutes";
import { getBoundDetails } from "./priorityBoardingHelperUtils";

export function usePriorityBoardingConfirmationAnalytics(reservation) {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);

  useEffect(() => {
    if (pathname === PRIORITY_BOARDING_ROUTES.confirmation) {
      setMktgPageData(
        {
          air_triptype: getTripType(reservation?.tripType),
          confirmation_number: reservation?.confirmationNumber,
          ...getBoundDetails(reservation?.selectedSegments),
        },
        "priorityBoardingConfirmation"
      );
    }
  }, [pathname, reservation]);
}
